export const COMPACT_WIDGET_LOGO_CENTER = 96;
export const COMPACT_WIDGET_SHELL_WIDTH = 192;
export const COMPACT_WIDGET_UPDATE_SHELL_WIDTH = 228;

interface ClampCompactWidgetOffsetOptions {
  requestedOffset: number;
  viewportWidth: number;
  shellWidth: number;
  logoCenter?: number;
  edgePadding?: number;
}

export function clampCompactWidgetOffset({
  requestedOffset,
  viewportWidth,
  shellWidth,
  logoCenter = COMPACT_WIDGET_LOGO_CENTER,
  edgePadding = 12,
}: ClampCompactWidgetOffsetOptions): number {
  const viewportCenter = viewportWidth / 2;
  const minimumOffset = edgePadding + logoCenter - viewportCenter;
  const maximumOffset =
    viewportCenter - edgePadding - (shellWidth - logoCenter);

  if (minimumOffset > maximumOffset) {
    return (minimumOffset + maximumOffset) / 2;
  }

  return Math.min(maximumOffset, Math.max(minimumOffset, requestedOffset));
}

export function clampCompactWidgetTop(
  top: number,
  viewportHeight: number,
): number {
  return Math.min(Math.max(8, viewportHeight - 44), Math.max(8, top));
}
